<section>
  <div class="container">
    <p-tabView styleClass="tabview-custom" [activeIndex]="productType || 0">
      <p-tabPanel>
        <ng-template pTemplate="header">
          <div class="flex align-items-center gap-2">
            <!-- <i class="tabview-icon ph-duotone ph-users"></i> -->
            <!-- <span class="material-icons-two-tone"> pool </span> -->
            <span class="font-bold white-space-nowrap m-0 block md:hidden">
              Recreativo
            </span>
            <span class="font-bold white-space-nowrap m-0 hidden md:block">
              Buceadores recreativos
            </span>
          </div>
        </ng-template>
        <app-insurance-dataview [items]="productType1"></app-insurance-dataview>
      </p-tabPanel>
      <p-tabPanel>
        <ng-template pTemplate="header">
          <div class="flex align-items-center gap-2">
            <!-- <span class="material-icons-two-tone"> houseboat </span> -->
            <span
              class="font-bold white-space-nowrap m-0 hidden sm:block md:hidden">
              Centros
            </span>
            <span class="font-bold white-space-nowrap m-0 hidden md:block">
              Centros de buceo
            </span>
          </div>
        </ng-template>
        <app-insurance-dataview [items]="productType2"></app-insurance-dataview>
      </p-tabPanel>

      <p-tabPanel>
        <ng-template pTemplate="header">
          <div class="flex align-items-center gap-2">
            <!-- <span class="material-icons-two-tone"> directions_boat </span> -->
            <span
              class="font-bold white-space-nowrap m-0 hidden sm:block md:hidden">
              Profesional
            </span>
            <span class="font-bold white-space-nowrap m-0 hidden md:block">
              Buceo profesional / comercial
            </span>
          </div>
        </ng-template>
        <app-insurance-dataview [items]="productType3"></app-insurance-dataview>
      </p-tabPanel>

      <p-tabPanel>
        <ng-template pTemplate="header">
          <div class="flex align-items-center gap-2">
            <!-- <span class="material-icons-two-tone"> scuba_diving </span> -->
            <span
              class="font-bold white-space-nowrap m-0 hidden sm:block md:hidden">
              Instructores
            </span>
            <span class="font-bold white-space-nowrap m-0 hidden md:block">
              Instructores y Divemasters
            </span>
          </div>
        </ng-template>
        <app-insurance-dataview [items]="productType4"></app-insurance-dataview>
      </p-tabPanel>
    </p-tabView>
  </div>
</section>
